module.exports = __webpack_public_path__ + "img/191.toiletries.026b7664.svg";